module.exports = "/_next/static/images/building-digital-uk-3d0639afd251a52d52a84b169d5aa614.svg";